import { useState, useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { Fancybox } from '@fancyapps/ui';
import doNotChoosenColorIMG from '../img/do-not-choose-pic.jpg';
import axios from 'axios';
import '@fancyapps/ui/dist/fancybox/fancybox.css';
import '../css/setColor.css';

const PATH_IMG = process.env.REACT_APP_IMG_URL;
const PATH_API = process.env.REACT_APP_API_URL;

function ColorsOfProducer({ arrayProducer, selectedProducer, selectedColor, searchValue }) {
    // selectedProducer нужен только для Фтем, т.к. он не имеет уникального цвета и приходится цвет объединять с именем
    const { register } = useFormContext();
    const arrayFiltered = arrayProducer.filter((stone) =>
        searchValue ? stone.color.includes(searchValue) || stone.name.toLowerCase().includes(searchValue.toLowerCase()) : true
    );

    return arrayFiltered.map((stone, index) => (
        <div key={stone.color} className="wrapp-img">
            <label htmlFor={stone.color}>
                <input
                    id={stone.color}
                    type="radio"
                    {...register('stone.color', { required: 'Выберите цвет/изображение камня' })}
                    value={stone.color}
                />
                <img
                    id={stone.color}
                    className={selectedColor === stone.color ? 'selected' : undefined}
                    src={PATH_IMG + stone.min}
                    alt={selectedProducer === 'atem' ? stone.color : stone.color + ' ' + stone.name}
                />
                <span>{selectedProducer === 'atem' ? stone.color : stone.color + ' ' + stone.name}</span>
            </label>
        </div>
    ));
}

export default function SetColor() {
    const { register, watch, setValue } = useFormContext();
    const selectedColor = watch('stone.color'); // текущее выбранное значение
    const selectedProducer = watch('stone.producer');
    const [producers, setProducers] = useState([]);
    const [arrayProducer, setArrayProducer] = useState([]);
    const [selectedColorDATA, setSelectedColorDATA] = useState({});
    const [searchValue, setSearchValue] = useState('');

    // it is needed because of fancybox - make a pic bigger
    useEffect(() => {
        Fancybox.bind('[data-fancybox]');
        return () => {
            Fancybox.unbind('[data-fancybox]');
            Fancybox.close();
        };
    }, []);

    useEffect(() => {
        setValue('stone.color', '');
        setSelectedColorDATA({});
        axios
            .get(PATH_API + '/' + selectedProducer)
            .then((response) => setArrayProducer(response.data))
            .catch((err) => alert('Error when executed AXIOS in request the producer price. The error is:', err));
    }, [selectedProducer, setValue]);

    useEffect(() => {
        axios
            .get(PATH_API + '/producers')
            .then((response) => {
                setProducers(response.data);
            })
            .catch((err) => alert('Error when executed AXIOS in request producers names with logo. The error is:', err));
    }, []);

    useEffect(() => {
        if (selectedColor !== '') {
            axios
                .get(PATH_API + '/' + selectedProducer + '/' + selectedColor)
                .then((response) => {
                    setSelectedColorDATA(response.data[0]);
                })
                .catch((err) => alert('Error when executed AXIOS in request max pic by color name. The error is:', err));
        }
        // eslint-disable-next-line
    }, [selectedColor]);

    const handlerSearch = (event) => {
        setSearchValue(event.target.value);
    };

    return (
        <>
            <div className="step-title">
                <h2 className="num-step-title">3</h2>
                <h2>Производитель и цвет камня:</h2>
            </div>
            <div className="wrapper-4">
                {/* two blocks 'block-producers' are for mobile responsive variant*/}
                <div id="list-producers" className="block-producers">
                    <div className="producers">
                        {producers
                            .filter((producer) => producer.id <= 5)
                            .map((producer) => (
                                <div className={`wrapp-img-producers ${producer.name === selectedProducer && 'selected'}`} key={producer.name}>
                                    <label>
                                        <input type="radio" {...register('stone.producer')} value={producer.name} />
                                        <img id={producer.name} src={PATH_IMG + '/logos/' + producer.image} alt={producer.name} />
                                    </label>
                                </div>
                            ))}
                    </div>
                    <div className="producers">
                        {producers
                            .filter((producer) => producer.id > 5)
                            .map((producer) => (
                                <div className={`wrapp-img-producers ${producer.name === selectedProducer && 'selected'}`} key={producer.name}>
                                    <label>
                                        <input type="radio" {...register('stone.producer')} value={producer.name} />
                                        <img id={producer.name} src={PATH_IMG + '/logos/' + producer.image} alt={producer.name} />
                                    </label>
                                </div>
                            ))}
                    </div>
                </div>
                <div className="right-side">
                    <div className="color-choice">
                        <div className="current-color">
                            {selectedColor === '' ? (
                                <img id="current-color" src={doNotChoosenColorIMG} style={{ cursor: 'default' }} alt="Цвет не выбран" />
                            ) : (
                                <a data-fancybox="image" href={PATH_IMG + selectedColorDATA.max}>
                                    <img
                                        id="current-color"
                                        src={PATH_IMG + selectedColorDATA.max}
                                        style={{ cursor: 'pointer' }}
                                        alt={selectedColor}
                                    />
                                    <div className="zoom-icon"></div>
                                </a>
                            )}
                        </div>
                        <div id="list-spec-colors" className="spec-color">
                            <p>Торговая марка:</p>
                            <p className="fillable" id="trade-mark">
                                {selectedProducer.toUpperCase()}
                            </p>
                            <p>Цвет:</p>
                            <p className="fillable" id="slab-color">
                                {' '}
                                {selectedColorDATA.color || 'Цвет не выбран'}&nbsp;
                                {selectedProducer !== 'atem' ? selectedColorDATA.name : undefined}
                            </p>
                            <p>Размер листа:</p>
                            <p className="fillable" id="size-1">
                                (N) 12 мм:&nbsp;
                                {+selectedColorDATA.thinLength ? selectedColorDATA.thinLength + ' x ' + selectedColorDATA.thinHeight : '-'}
                            </p>
                            <p className="fillable" id="size-2">
                                (N) 20 мм:&nbsp;
                                {+selectedColorDATA.normalLength ? selectedColorDATA.normalLength + ' x ' + selectedColorDATA.normalHeight : '-'}
                            </p>
                            <p className="fillable" id="size-3">
                                (J) 20 мм:&nbsp;
                                {+selectedColorDATA.jamboLength ? selectedColorDATA.jamboLength + ' x ' + selectedColorDATA.jamboHeight : '-'}
                            </p>
                        </div>
                    </div>

                    <div className="wrapp-input">
                        <div className="text-field__icon-2 text-field__icon-2_search">
                            <input
                                id="search"
                                className="text-field__input"
                                type="text"
                                onChange={handlerSearch}
                                placeholder="название или номер цвета"
                            />
                        </div>
                    </div>

                    <div id="list-colors" className="colors">
                        <ColorsOfProducer
                            arrayProducer={arrayProducer}
                            selectedProducer={selectedProducer}
                            selectedColor={selectedColor}
                            searchValue={searchValue}
                        />
                    </div>
                </div>
            </div>
        </>
    );
}
